import React, { useContext } from "react";
import PropTypes from "prop-types";
import { SimpleContext } from "../../../../store/context/simple-context";
import { getTrueClasses } from "../../../../helpers";
import "./index.scss";

const Question = (props) => {
  const { tooltip, leftView, rightView, bottomView, isComplexContent } = props;
  if (!tooltip) {
    return null;
  }
  const {
    translate: { t },
  } = useContext(SimpleContext);

  const classes = getTrueClasses(
    "GP-C-Q__tooltip",
    leftView && "GP-C-Q__tooltip_left",
    rightView && "GP-C-Q__tooltip_right",
    bottomView && "GP-C-Q__tooltip_bottom"
  );
  return isComplexContent ? (
    <div className="GP-C-Q">
      <div className={classes}>{tooltip}</div>
    </div>
  ) : (
    <span className="GP-C-Q">
      <span className={classes}>{t(tooltip)}</span>
    </span>
  );
};

Question.propTypes = {
  leftView: PropTypes.bool,
  rightView: PropTypes.bool,
  bottomView: PropTypes.bool,
  isComplexContent: PropTypes.bool,
};

export default Question;
